import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import Popper from '@mui/material/Popper';
import { useTheme, styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./SearchBar.css"

function SearchBar() {
  const [allOptions, setAllOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const navigate = useNavigate();

  const sortPlayerOptions = (list) => {
    return [...list].sort((a, b) => {
      const aName = `${a.last_name} ${a.first_name}`.toLowerCase();
      const bName = `${b.last_name} ${b.first_name}`.toLowerCase();
      return aName.localeCompare(bName);
    });
  };

  const StyledPopper = styled(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
      boxSizing: 'border-box',
      backgroundColor: '#1a1f25',
      color: '#f3f4f6',
      border: '1px solid rgba(255, 255, 255, 0.09)',
      borderRadius: '10px',
      padding: '4px',
      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.45)',
      fontFamily: "'Inter', sans-serif",

      '& li': {
        borderRadius: '6px',
        padding: '8px 12px',
        fontSize: '14px',
        transition: 'background-color 0.12s ease',
      },
      '& li:hover': {
        backgroundColor: 'rgba(126, 168, 98, 0.12)',
      },
    },
  });


  // ONLY QUERY API IF INPUT VALUE IS 3 CHARACTERS, OTHERWISE FILTER OPTIONS LOCALLY
  const handleInputChange = (event, value) => {
    setInputValue(event.target.value);
    if (event.target.value.length == 3) {
      // Call API to populate dropdown options
      fetchOptions(event.target.value);
    } else if (event.target.value.length > 3) {
      const constructedPlayerId = event.target.value.replace(/\s/g, '_').toLowerCase();
      const filtered = allOptions.filter((option) => option.player_id.includes(constructedPlayerId));
      setOptions(sortPlayerOptions(filtered));
    }
    else {
      setOptions([]); // Clear options if less than 3 characters
    }
  };

  const fetchOptions = async (value) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + "/players/search/" + value);
      const sorted = sortPlayerOptions(response.data);
      setAllOptions(sorted);
      setOptions(sorted);
    } catch (error) {
      console.error('Error fetching options:', error);
    }
  };


  return (
    <Autocomplete
      className="autocomplete-search-bar"
      PopperComponent={StyledPopper}
      forcePopupIcon={false}
      options={options}
      getOptionLabel={(option) => (option.first_name + " " + option.last_name)}
      onChange={(event, option) => {
        setOptions([]);
        if (option){
          navigate('/player/' + option.player_id);
        }
        
      }
      }
      renderInput={(params) => (
        <TextField
          className="search-bar"
          {...params}
          label="Player Search"
          value={inputValue}
          onChange={handleInputChange}
        />
      )}
    />
  );
};


export default SearchBar;